import {getThemes} from '../queries/theme';
import { useMutation } from '@tanstack/react-query';

export function useEssayThemes() {
  const { mutate, isPending, isError } = useMutation({
    mutationKey: ['essay-themes'],
    mutationFn: () => getThemes(),
    retry: false
  });

  return {
    isPending,
    mutate,
    isError
  }
}